import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
@Component({
  selector: 'ui-egov-status-pbmeet',
  templateUrl: './statuspb.component.html',
  encapsulation: ViewEncapsulation.None
})
export class StatusMeetingPBComponent  implements  OnInit {
  @Input() typeStatus: number;
  public language = language;
  ngOnInit(): void {

  }

}
